import {
  GET_AUTOCOMPLETE_LOCATION,
  GET_AUTOCOMPLETE_LOCATION_SUCCESS,
  GET_AUTOCOMPLETE_LOCATION_ERROR,
  GET_AUTOCOMPLETE_LOCATION_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const getAutoCompleteLocation = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTOCOMPLETE_LOCATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_AUTOCOMPLETE_LOCATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_AUTOCOMPLETE_LOCATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_AUTOCOMPLETE_LOCATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getAutoCompleteLocation;
